import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { WebsiteLayout } from '../features/website/layouts/WebsiteLayout.js';
import { HomePage } from '../features/website/pages/HomePage.js';
import { BusinessPage } from '../features/website/pages/BusinessPage.js';
import { LocationsPage } from '../features/website/pages/LocationsPage.js';
import { InvoicePage } from '../features/website/pages/InvoicePage.js';
import { PrivacyPolicyPage } from '../features/website/pages/PrivacyPolicyPage.js';

const router = createBrowserRouter([
  {
    path: '/',
    element: <WebsiteLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'empresas',
        element: <BusinessPage />,
      },
      {
        path: 'sucursales',
        element: <LocationsPage />,
      },
      {
        path: 'facturacion',
        element: <InvoicePage />,
      },
      {
        path: 'aviso-de-privacidad',
        element: <PrivacyPolicyPage />,
      },
      {
        path: 'en',
        element: <HomePage isEn />,
      },
      {
        path: 'en/business',
        element: <BusinessPage isEn />,
      },
      {
        path: 'en/locations',
        element: <LocationsPage isEn />,
      },
      {
        path: 'en/invoicing',
        element: <InvoicePage isEn />,
      },
    ],
  },
  // Redirecciones de seguridad y compatibilidad desde /sitio hacia la raíz
  {
    path: '/sitio',
    element: <Navigate to="/" replace />,
  },
  {
    path: '/sitio/aviso-de-privacidad',
    element: <Navigate to="/aviso-de-privacidad" replace />,
  },
  {
    path: '/sitio/empresas',
    element: <Navigate to="/empresas" replace />,
  },
  {
    path: '/sitio/sucursales',
    element: <Navigate to="/sucursales" replace />,
  },
  {
    path: '/sitio/facturacion',
    element: <Navigate to="/facturacion" replace />,
  },
  {
    path: '/sitio/en',
    element: <Navigate to="/en" replace />,
  },
  {
    path: '/sitio/en/business',
    element: <Navigate to="/en/business" replace />,
  },
  {
    path: '/sitio/en/locations',
    element: <Navigate to="/en/locations" replace />,
  },
  {
    path: '/sitio/en/invoicing',
    element: <Navigate to="/en/invoicing" replace />,
  },
  // Cualquier otra ruta operativa o desconocida redirige a la raíz de la web corporativa
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
